import React, { useState } from 'react';
import { Dialog } from "../../../components/Dialog/Dialog";
import { DialogTitle } from "../../../components/Dialog/DialogTitle";
import { HeaderTabButtonGroup } from "../../../components/HeaderTabButtonGroup/HeaderTabButtonGroup";
import { useTranslation } from "../../../hooks/useTranslation";
import { makeStyles } from "../../../styles/index";
import { isWorkSelectDialogTabId, WORK_SELECT_DIALOG_TABS, WORK_SELECT_DIALOG_TAB_ID, } from "../constants/work-maker";
import { WorkTab } from "../WorkTab/WorkTab";
import { WorkTemplateTab } from "../WorkTemplateTab/WorkTemplateTab";
var useStyles = makeStyles(function () { return ({
    tab: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end',
        minHeight: 64,
        position: 'relative',
    },
}); }, { name: 'SnWorkSelectDialog' });
export var WorkSelectDialog = function (_a) {
    var open = _a.open, defaultWork = _a.defaultWork, maxSelectableWorkNumber = _a.maxSelectableWorkNumber, schoolType = _a.schoolType, selectionGrades = _a.selectionGrades, selectionSubjects = _a.selectionSubjects, workTemplateOnly = _a.workTemplateOnly, templateGroups = _a.templateGroups, onChangeGrade = _a.onChangeGrade, onSelectWork = _a.onSelectWork, onSelectWorkTemplate = _a.onSelectWorkTemplate, onCancel = _a.onCancel;
    var t = useTranslation().t;
    var classes = useStyles();
    var _b = useState(templateGroups == null ? WORK_SELECT_DIALOG_TAB_ID.WORK : WORK_SELECT_DIALOG_TAB_ID.TEMPLATE), tabId = _b[0], setTabId = _b[1];
    var handleChangeTab = function (id) {
        if (isWorkSelectDialogTabId(id)) {
            setTabId(id);
        }
    };
    return (React.createElement(Dialog, { open: open, fullScreen: true },
        React.createElement(DialogTitle, null, t('ワークを選ぶ')),
        !workTemplateOnly && (React.createElement("div", { className: classes.tab },
            React.createElement(HeaderTabButtonGroup, { tabs: WORK_SELECT_DIALOG_TABS, value: tabId, width: 300, onChange: handleChangeTab }))),
        !workTemplateOnly && tabId === WORK_SELECT_DIALOG_TAB_ID.WORK && (React.createElement(WorkTab, { open: open, defaultWork: defaultWork, maxSelectableWorkNumber: maxSelectableWorkNumber, schoolType: schoolType, onSelect: onSelectWork, onCancel: onCancel })),
        (workTemplateOnly || tabId === WORK_SELECT_DIALOG_TAB_ID.TEMPLATE) && (React.createElement(WorkTemplateTab, { maxSelectableWorkNumber: maxSelectableWorkNumber, selectionGrades: selectionGrades, selectionSubjects: selectionSubjects, templateGroups: templateGroups, onChangeGrade: onChangeGrade, onSelect: onSelectWorkTemplate, onCancel: onCancel }))));
};
